<!--
 * @Author: yxr
 * @Date: 2020-03-18 17:08:54
 * @LastEditors: DQL
 * @LastEditTime: 2021-04-30 15:27:05
 * @Description: 关联权限部门
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="数据权限配置"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="110px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <!--用户基本信息-->
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份代码"
              prop="capacityCode"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.capacityCode }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份名称"
              prop="capacityName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.capacityName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
              prop="deptName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.userVO.deptName }}
              </span>
            </el-form-item>
          </el-col>
          <!--用户权限部门树-->
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-tree
              ref="tree"
              class="c-form__tree o-tree-overflow--unset"
              style="height: 278px;overflow: auto;"
              show-checkbox
              node-key="nodeCode"
              :data="fd.allDeptTreeList"
              :check-strictly="checkStrictly"
              :default-expanded-keys="fd.permissionDeptTreeList"
              :default-checked-keys="fd.permissionDeptTreeList"
              :props="defaultProps"
              @check-change="handleCheckChange"
            />
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { allDeptTree, permissionDeptTree, savePermission } from '../user.service';

export default {
  name: 'RelatePermissionDept',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面loading状态

      /* 树组件配置 Start */
      permissionArr: [], // 选中的权限部门数组
      checkStrictly: true, // 树结构多选框勾选时不自动关联父元素
      // 树组件默认参数配置
      defaultProps: {
        key: 'nodeCode',
        children: 'childNodes',
        label: 'nodeName'
      },
      /* 树组件配置 End */

      /* 表单参数 Start */
      fd: {
        userVO: {
          capacityCode: null, // 身份代码
          capacityName: null, // 身份名称
          deptName: null // 所属部门名称
        },
        allDeptTreeList: [], // 部门树数组
        permissionDeptTreeList: [] // 权限部门数组
      }
      /* 表单参数 End */
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 初始化机构部门树
     * @param {*}
     * @return {*}
     */
    getAllDeptTree () {
      this.loading = true;
      allDeptTree()
        .then(rsp => {
          this.fd.allDeptTreeList = rsp.data;
          this.loading = false;
        })
        .catch(err => {
          console.log('初始化机构部门树错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 获取指定身份权限部门
     * @param {*}
     * @return {*}
     */
    getPermissionDeptTree () {
      this.loading = true;
      permissionDeptTree({ capacityCode: this.dlParams.capacityCode })
        .then(rsp => {
          const permissionDeptTreeListTemp = [];
          for (const s of rsp.data) {
            permissionDeptTreeListTemp.push(s.deptCode);
          }
          this.fd.permissionDeptTreeList = permissionDeptTreeListTemp;
          this.loading = false;
        })
        .catch(err => {
          console.log('获取指定身份权限部门错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 保存权限部门修改
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.loading = true;
      const permission = { capacityCode: this.dlParams.capacityCode, deptList: this.permissionArr };
      savePermission(permission)
        .then(rsp => {
          this.$alert('关联成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 部门树勾选回调方法
     * @param {*}
     * @return {*}
     */
    handleCheckChange () {
      const res = this.$refs.tree.getCheckedNodes();
      const temp = [];
      res.forEach((item) => {
        temp.push(item.nodeCode);
      });
      this.permissionArr = temp;
    }
  },
  created () {
    this.fd.userVO.capacityCode = this.dlParams.capacityCode;
    this.fd.userVO.capacityName = this.dlParams.capacityName;
    this.fd.userVO.deptName = this.dlParams.deptName;
  },
  mounted () {
    this.getAllDeptTree();
    this.getPermissionDeptTree();
  }
};
</script>
